import { useState, useEffect } from 'react';
import { IUseQueryReviewParams } from './types';

const useQueryReview = ({ isOpen, onClose, onApprove }: IUseQueryReviewParams) => {
  const [acknowledged, setAcknowledged] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setAcknowledged(false);
    }
  }, [isOpen]);

  const handleApprove = async () => {
    onClose();
    await onApprove();
  };

  return {
    acknowledged,
    setAcknowledged,
    handleApprove,
  };
};

export default useQueryReview;
